import { render, staticRenderFns } from "./HostedVlanServiceWizard.vue?vue&type=template&id=8a5f526e&"
import script from "./HostedVlanServiceWizard.vue?vue&type=script&lang=js&"
export * from "./HostedVlanServiceWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports